import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import DiscoveryPillBarLayout from './layouts/discovery-pill-layout';
import SellPillBarLayout from './layouts/sell-pill-layout';

import '../styles/index.scss';

function PillBar({leftSection = [], rightSection = [], isSell = false, className}) {
  const tabSection = (item) => {
    const {
      tabNames = [],
      cojoinedTabs,
      tabsConfig = [],
      selectedTabName,
      theme = {},
      themeProvider = () => {
        //
      },
      themeBackgroundColor = () => {
        //
      },
      disableTheme = false,
      onTabClickHandler,
    } = item.tabParams;

    const tabButtons = tabNames.map((tabName, index) =>
      tabName ? (
        <button
          type="button"
          className={cs(
            !disableTheme && selectedTabName === tabName
              ? `selected ${themeBackgroundColor(theme, themeProvider)}`
              : selectedTabName === tabName
              ? 'selected'
              : '',
            'pill-bar-item',
            'pill-bar-button',
            cojoinedTabs
              ? `pill-bar-${index === 0 ? 'left' : index === tabNames.length - 1 ? 'right' : 'middle'}-item`
              : ''
          )}
          key={`pill-bar-button-${tabName}-${index}`}
          onClick={() => onTabClickHandler(tabName)}
        >
          {tabsConfig[tabName].icon && <span className="pill-bar-icon">{tabsConfig[tabName].icon}</span>}
          <span className="pill-bar-text">{tabsConfig[tabName].displayName}</span>
        </button>
      ) : null
    );

    return tabButtons;
  };

  const processSection = (section) => {
    return section.map((item, index) =>
      item && item.itemType === 'tabs' ? (
        tabSection(item)
      ) : item && item.control ? (
        <button
          type="button"
          className={cs('pill-bar-item', {NoLabel: item.noLabel})}
          key={`pill-bar-control-item-${index}`}
          aria-label="filter button"
        >
          <span className="pill-bar-text">{item.control}</span>
        </button>
      ) : item ? (
        <button type="button" className="pill-bar-item" key={`pill-bar-item-${item}-${index}`}>
          <span className="pill-bar-text">{item}</span>
        </button>
      ) : null
    );
  };
  const leftSectionBar = processSection(leftSection);
  const rightSectionBar = processSection(rightSection);

  const isEmpty = (arr) => {
    return !arr || arr.length === 0;
  };

  const PillBarLayout = isSell ? SellPillBarLayout : DiscoveryPillBarLayout;

  /** For sell pill bar, either leftSection or rightSection is passed at once, not both simulataneously */
  const sellPillBarOrientation = isSell ? (isEmpty(leftSectionBar) ? 'right' : 'left') : null;

  return (
    <PillBarLayout
      leftSectionBar={leftSectionBar}
      rightSectionBar={rightSectionBar}
      className={className}
      orientation={sellPillBarOrientation}
    />
  );
}

PillBar.propTypes = {
  leftSection: PropTypes.array,
  rightSection: PropTypes.array,
  isSell: PropTypes.bool,
  className: PropTypes.string,
};

export default PillBar;
